import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.scss";

const CookieConsent = () => {
  useEffect(() => {
    if (
      !COOKIE_CONSENT_MANAGEMENT_PLATFORM_ENABLED
      && typeof window !== "undefined"
    ) {
      // Initialize cookieconsent
      window.cookieconsent.initialise({
        content: {
          dismiss: "Okay, got it",
          message: `By using the website you agree to our
            <a href="https://${DOMAIN}/cookies" title="Cookie Policy" class="cc-policy-link"> cookie policy</a>`,
        },
        cookie: {
          domain: `.${DOMAIN}`,
        },
        dismissOnTimeout: 30000,
        position: "bottom",
        showLink: false,
        theme: "trussle",
        window: `<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc"
           class="cc-window {{classes}}"><div class="cc-content">{{children}}</div></div>`,
      });
    }
  }, []);

  return COOKIE_CONSENT_MANAGEMENT_PLATFORM_ENABLED ? (
    <Helmet>
      <script
        src="https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js"
        data-domain-script={COOKIE_CONSENT_MANAGEMENT_PLATFORM_ACCOUNT_ID}
      />
    </Helmet>
  ) : null;
};

export default CookieConsent;
